export function getErrorName(error: unknown): string {
  return error instanceof Error ? error.name : typeof error
}

export function errorToString(error: unknown): string {
  if (!error) {
    return 'Unknown error'
  }

  if (error instanceof Error) {
    return error.message || 'Error occurred'
  }

  if (typeof error === 'string') {
    return error
  }

  if (typeof error === 'number' || typeof error === 'boolean') {
    return String(error)
  }

  // Handle objects with message property
  if (typeof error === 'object' && error !== null) {
    const errorObj = error as Record<string, unknown>

    if ('message' in errorObj) {
      return String(errorObj.message)
    }

    if ('error' in errorObj) {
      return String(errorObj.error)
    }

    if ('reason' in errorObj) {
      return String(errorObj.reason)
    }

    if ('description' in errorObj) {
      return String(errorObj.description)
    }
  }

  return ''
}
